import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.name || !formData.message) return;
    setSubmitting(true);
    const body = new URLSearchParams();
    body.append('name', formData.name);
    body.append('phone', formData.phone);
    body.append('message', formData.message);
    try {
      await fetch('https://readdy.ai/api/form/d775df2bj7ht1ofp4eag', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20 max-w-[480px] mx-auto">
      <header className="sticky top-0 z-40 bg-white border-b border-gray-100">
        <div className="flex items-center px-4 h-14 gap-3">
          <button onClick={() => navigate(-1)} className="w-8 h-8 flex items-center justify-center cursor-pointer">
            <i className="ri-arrow-left-line text-gray-700 text-xl" />
          </button>
          <h1 className="font-bold text-gray-900 text-base">客服中心</h1>
        </div>
      </header>

      {/* 服务时间 */}
      <div className="bg-white mx-4 mt-3 rounded-2xl p-5">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-50 flex-shrink-0">
            <i className="ri-time-line text-xl text-sky-500" />
          </div>
          <div>
            <p className="text-xs text-gray-400">服务时间</p>
            <p className="text-sm font-medium text-gray-800 mt-0.5">周一至周日 9:00 - 12:00 / 13:00 - 18:00</p>
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white mx-4 mt-3 rounded-2xl p-5">
        <h3 className="font-bold text-gray-900 text-base mb-1">在线留言</h3>
        <p className="text-xs text-gray-400 mb-4">留下您的问题，我们会尽快与您联系</p>
        {submitted ? (
          <div className="flex flex-col items-center py-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-full mb-3">
              <i className="ri-check-line text-emerald-500 text-2xl" />
            </div>
            <p className="font-semibold text-gray-900 mb-1">留言已提交！</p>
            <p className="text-sm text-gray-500">我们会在1个工作日内回复您</p>
          </div>
        ) : (
          <form data-readdy-form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="text-xs text-gray-500 mb-1 block">姓名 *</label>
              <input
                name="name"
                type="text"
                placeholder="请输入您的姓名"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-rose-300"
                required
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">手机号</label>
              <input
                name="phone"
                type="tel"
                placeholder="请输入您的手机号（选填）"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-rose-300"
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">留言内容 *</label>
              <textarea
                name="message"
                placeholder="请输入您的留言..."
                value={formData.message}
                onChange={(e) => {
                  if (e.target.value.length <= 500) setFormData({ ...formData, message: e.target.value });
                }}
                rows={4}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-rose-300 resize-none"
                required
              />
              <p className="text-xs text-gray-400 text-right mt-1">{formData.message.length}/500</p>
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-rose-500 text-white py-3 rounded-full font-medium text-sm cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {submitting ? '提交中...' : '提交留言'}
            </button>
          </form>
        )}
      </div>

      {/* Social */}
      <div className="bg-white mx-4 mt-3 mb-4 rounded-2xl p-5">
        <h3 className="text-sm font-semibold text-gray-900 text-center mb-4">关注我们</h3>
        <div className="flex justify-center gap-4">
          {[
            { icon: 'ri-wechat-line', color: 'text-emerald-500', bg: 'bg-emerald-50', label: '微信' },
            { icon: 'ri-weibo-line', color: 'text-rose-500', bg: 'bg-rose-50', label: '微博' },
            { icon: 'ri-tiktok-line', color: 'text-gray-800', bg: 'bg-gray-100', label: '抖音' },
            { icon: 'ri-instagram-line', color: 'text-pink-500', bg: 'bg-pink-50', label: '小红书' },
          ].map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1.5">
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${s.bg} cursor-pointer`}>
                <i className={`${s.icon} text-xl ${s.color}`} />
              </div>
              <span className="text-xs text-gray-500">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
